$(() => {
  new Vue({
    el: document.querySelector(".v-deposits-controller"),
  });
});
